import { useMutation } from '@apollo/client/react';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';

import { CreateCheckinEntryDocument } from '~/graphql/generated/graphql';

import { Fields } from './types';

export const useCheckinEntry = (checkinOrganizationId?: string) => {
  const [isChecking, setIsChecking] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();
  const [checkin, { loading, data }] = useMutation(CreateCheckinEntryDocument);

  useEffect(() => {
    const id = data?.createCheckinEntry?.publicCheckinEntry.id;
    if (!id || !checkinOrganizationId) return;

    void router.push(`/checkin/${checkinOrganizationId}/result/${id}`);
  }, [checkinOrganizationId, data, router]);
  const handleSubmit = useCallback(
    (values: Fields) => {
      const { isAgree, ...submitValues } = values;

      if (!checkinOrganizationId || !isAgree) return;

      setIsChecking(true);
      setError(null);

      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(process.env.reCAPTCHASiteKey, {
            action: 'checkin',
          });

          await checkin({
            variables: {
              input: {
                ...submitValues,
                checkinOrganizationId,
                response: token,
              },
            },
          });
        } catch (error) {
          setError(error?.message || 'エラーが発生しました');
        }
        setIsChecking(false);
      });
    },
    [checkin, checkinOrganizationId],
  );

  return {
    isChecking,
    error,
    handleSubmit,
    loading,
  };
};
